<template>
  <section
    v-if="ready"
  >
    <div class="top">
      <template v-if="!degraded">
        <div class="row">
          <strong
            v-html="$t('components.quotation_agency.suggested_plan', {days: detail.jourfact})"
            v-if="detail.jourfact > 1"
          />
          <strong
            v-else
            v-html="$t('components.quotation_agency.suggested_plan_day')"
          />
          <strong
            v-html="$t('components.quotation_agency.price', {total: detail.totalttc, pricePerDay})"
            v-if="jourFact > 1"
            class="price"
          />
          <strong
            v-else
            v-html="$t('components.quotation_agency.price_one_day', {total: detail.totalttc})"
            class="price"
          />
        </div>
        <div class="row -small">
          <span
            v-html="$t('components.quotation_agency.kilometers', {includedKm, price: detail.prixUnitKMSUPTTC})"
            v-if="includedKm < 9999"
          />
          <span
            v-else
          >{{ $t('components.quotation_agency.kilometers_unlimited') }}</span>
          <span
            v-html="$t('components.quotation_agency.reference_price', {price: detail.totalSansRemise})"
          />
        </div>
      </template>
      <div
        v-else
        class="row"
      >
        <strong v-html="$t('components.quotation_agency.degraded_heading', {degradedPrice})" />
      </div>
    </div>
    <div class="agencies">
      <a
        href="/vehicules?changer_agences"
        aria-label="modifier"
      >
        <svg>
          <use xlink:href="#icon-pencil"></use>
        </svg>
      </a>
      <agency-info
        heading="agence de départ"
        :business="business.pickUp.business"
      />
      <agency-info
        v-if="!degraded"
        heading="agence d'arrivée"
        :business="business.drop.business"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { centsInSpan } from '../../utils/euros'
import AgencyInfo from './AgencyInfo'

export default {
  name: 'QuotationAgency',
  props: {
    degraded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AgencyInfo,
  },
  computed: {
    ...mapState({
      business: (s) => s.booking,
      vehicle: (s) => s.vehicles.set.storeVehicle,
      allPrices: (s) => s.vehicles.prices.allPrices,
    }),
    ...mapGetters({
      detail: 'quotation/priceFormattedQuotation',
      pricePerDay: 'quotation/pricePerDay',
    }),
    ready() {
      if (this.degraded) {
        return this.business.pickUp.business && this.vehicle
      }
      return this.business.pickUp.business && this.vehicle && this.vehiclePrice && this.detail
    },
    imageSrc() {
      return this.vehicle.images.high
    },
    vehiclePrice() {
      return this.allPrices[this.vehicle.semi_clair]
    },
    detail() {
      return this.$store.getters['quotation/priceFormattedQuotation']
    },
    pricePerDay() {
      return `${centsInSpan(this.$store.getters['quotation/pricePerDay'])}`
    },
    includedKm() {
      return parseInt(this.detail.kilom1, 10)
    },
    jourFact() {
      return parseInt(this.detail.jourfact, 10)
    },
    degradedPrice() {
      return centsInSpan(this.vehicle.rrs_category.starting_price.raw)
    },
    extraKm() {
      return `${centsInSpan(this.detail.prixUnitKMSUPTTC)}`
    },
  },
}
</script>

<style lang="scss" scoped>

section {
  width: 100%;
}

.top {
  background: black;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 82px;
  padding: 10px 20px;

  @include font-size(20px);

  @include teq-breakpoint($large) {
    padding: 0 20px;
  }
}

.row {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @include teq-breakpoint($large) {
    flex-direction: row;
  }

  .-small,
  ::v-deep .-small {
    @include font-size(14px);

    font-family: $f-graphie-book;
    opacity: 0.5;
  }
}

strong {
  color: white;
  font-family: $f-graphie-bold;
  font-size: 24px;
  line-height: 28.8px;
}

strong ::v-deep span {
  color: white;
}

.price {
  align-self: self-start;

  @include teq-breakpoint($large) {
    align-self: auto;
  }
}

.agencies {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  position: relative;

  @include teq-breakpoint($large) {
    flex-direction: row;
  }
}

a {
  position: absolute;
  right: 15px;
  top: 15px;
}

svg {
  height: 15px;
  width: 15px;
}
</style>
